import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center md:items-start">
            <Logo />
            <p className="text-white mt-4 text-center md:text-left">
              Professional jet washing services for your property needs.
            </p>
          </div>
          
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-gold font-bold text-xl mb-4">Quick Links</h3>
            <ul className="space-y-2 text-center md:text-left">
              <li><Link to="/" className="text-white hover:text-gold transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-white hover:text-gold transition-colors">Services</Link></li>
              <li><Link to="/contact" className="text-white hover:text-gold transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-gold font-bold text-xl mb-4">Connect With Us</h3>
            <div className="space-y-2">
              <a 
                href="https://www.facebook.com/profile.php?id=61555453935419" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center text-white hover:text-gold transition-colors"
              >
                <Facebook size={20} className="mr-2" />
                <span>Follow us on Facebook</span>
              </a>
              <a 
                href="https://www.instagram.com/SiscaroSolutions" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center text-white hover:text-gold transition-colors"
              >
                <Instagram size={20} className="mr-2" />
                <span>Follow us on Instagram</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gold/30 text-center">
          <p className="text-white">
            &copy; {new Date().getFullYear()} Siscaro Property Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;